export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/

export function isValidEmail (email) {
  return !!emailRegex.test(email)
}

export default {
  data () {
    return {
      emailRegex: emailRegex,
    }
  },
  methods: {
    isValidEmail (email) {
      return !!this.emailRegex.test(email)
    },
  },
}
